import React from "react";
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import TenderListingController from '../../controllers/TenderListingController/TenderListingController'
import { 
  TenderListingContainer,
 } from './TenderListingPage.styles';

export default function TenderListingPage(){ 
  return(
    <TenderListingContainer>
      <Breadcrumbs />
      <TenderListingController />
    </TenderListingContainer>
  );
}